import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import * as _ from 'lodash';
import { LegacyDialogsService } from '../../../../../services/legacy-dialogs.service';

import { CuttingCustomGrooveSchema, GrooveTypeEnum } from 'cloud-shared-lib';
import { combineLatest, concatMap, map, Observable, tap } from 'rxjs';
import { CuttingPanelSlot } from '../../../../../models/cutting/cutting-panel-slot.model';
import { SlotsDialogComponent, SlotsDialogData } from '../../../../slots-dialog/slots-dialog.component';
import { CuttingPanelListService } from '../../../cutting-panel-list.service';

export type SidePosition = 'top' | 'bottom' | 'left' | 'right';

@Component({
  selector: 'csl-groove-select',
  templateUrl: './groove-select.component.html',
  styleUrls: ['./groove-select.component.scss'],
})
export class GrooveSelectComponent {
  _selected: CuttingPanelSlot;

  action$: Observable<any>;

  @Input() set selected(value: CuttingPanelSlot) {
    this._selected = value;
  }
  get selected(): CuttingPanelSlot {
    return this._selected;
  }
  @Input() editable = true;
  @Input() position: SidePosition;
  @Input() disabled = false;
  @Input() fullPanelThickness: number;
  @ViewChild('select', { static: true }) select: MatSelect;
  @Output() selectedChange: EventEmitter<CuttingPanelSlot> = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    private dialogs: LegacyDialogsService,
    private cuttingPanelListService: CuttingPanelListService
  ) {}

  setGroove(val: CuttingPanelSlot): void {
    if (!val) {
      return;
    }

    this._selected = _.cloneDeep(val);

    this.selectedChange.emit(this._selected);
  }

  getCustomSlotsSchemas(): Observable<CuttingCustomGrooveSchema[]> {
    return combineLatest([
      this.cuttingPanelListService.getCustomSlotSchemas(null),
      this.cuttingPanelListService.getCustomSlotOption(),
    ]).pipe(
      map(([schemas, o]) => {
        const typeAvailability = {
          [GrooveTypeEnum.InPlate]: o.inPlate,
          [GrooveTypeEnum.InSide]: o.inSide,
          [GrooveTypeEnum.Rabbet]: o.rabbet,
          [GrooveTypeEnum.Fillet]: o.fillet,
          [GrooveTypeEnum.Chamfer]: o.chamfer,
          [GrooveTypeEnum.Chamfer2]: o.chamfer2,
        };

        return schemas.filter(s => typeAvailability[s.type]);
      })
    );
  }

  openGrooveListDialog(): void {
    this.action$ = combineLatest([this.cuttingPanelListService.getSlots(), this.getCustomSlotsSchemas()]).pipe(
      concatMap(([slots, schemas]) =>
        this.dialogs.component(
          SlotsDialogComponent,
          {
            slots,
            fullPanelThickness: this.fullPanelThickness,
            deleteCustomSlot: this.cuttingPanelListService.deleteCustomSlot.bind(this.cuttingPanelListService),
            postCustomSlotsData: this.cuttingPanelListService.addCustomSlot.bind(this.cuttingPanelListService),
            customSlotSchemas: schemas,
          } as SlotsDialogData<CuttingCustomGrooveSchema, CuttingPanelSlot>,
          1000
        )
      ),
      tap((response: CuttingPanelSlot | undefined) => {
        if (response) {
          this.setGroove(response);
        }

        this.select.close();
      })
    );
  }

  selectionChange(item: CuttingPanelSlot | undefined): void {
    this._selected = item;
    this.selectedChange.emit(item);
  }
}
